import { ArrowLeftOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import D360LiveViewsTab from "./views_tab";

const D360LiveViews = () => {
  const { t } = useTranslation();
  const { weld_number } = useParams();

  return (
    <>
      <div className="slogweld-title">
        <Link to={"/data360Live"}>
          <div className="back_equip">
            <Tooltip title={"Back"}>
              <ArrowLeftOutlined />
            </Tooltip>
            <h2 className="slogweld-header-active">
              {t("slogColumntitle.logData")}
            </h2>
          </div>
        </Link>
        <div className="back_equip-unActive">
          <ArrowLeftOutlined />
          <h2 className="slogweld-header">
            {t("slogColumntitle.weld")} {weld_number}
          </h2>
        </div>
      </div>
      <D360LiveViewsTab weld_number={weld_number} />
    </>
  );
};

export default D360LiveViews;
